import React, { useState, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import { Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';
import RefreshToken from '../../../partials/RefreshToken';
import { AuthContext } from '../../../../@jumbo/components/context/AuthContext';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles(theme => ({
  alertRoot: {
    marginBottom: 10,
  },
  marginStyle: {
    margin: '7px 0',
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  alignCenter: {
    textAlign: 'center',
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  selectStyle: {
    [`& fieldset`]: {
      borderRadius: 25,
    },
    [`& .MuiSelect-outlined`]: {
      borderRadius: 25,
    },
  },
  buttonMarginStyle: {
    margin: '16px 0 22px 0',
  },
  buttonStyle: {
    borderRadius: 25,
  },
}));

const QuestionAddEdit = ({
  list,
  setList,
  editObj,
  setEditObj,
  editIndexNo,
  categoryList,
  selectedId,
  refresh,
  setRefresh,
  closeAddDialog,
  addDialog,
}) => {
  const classes = useStyles();
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);
  const userId = glob_pay_admin_auth.user.sub;
  const [id, setId] = useState('');

  const [mobileNumber, setMobileNumber] = useState('');
  const [applicableFor, setApplicableFor] = useState('');
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');

  const [status, setStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [addForm, setAddForm] = useState(true);
  const [editForm, setEditForm] = useState(false);
  const [categoryId, setCategoryId] = useState('');

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };
  const validation = () => {
    let isError = false;
    if (!categoryId.trim()) {
      console.log('categoryId', selectedId);
      handleSnakbarOpen('Please select category name', 'error');
      document.getElementById('categoryId').focus();
      return (isError = true);
    }
    if (!applicableFor.trim()) {
      handleSnakbarOpen('Please enter applicable For', 'error');
      document.getElementById('applicableFor').focus();
      return (isError = true);
    }

    if (!question.trim()) {
      console.log('continent');
      handleSnakbarOpen('Please enter question', 'error');
      document.getElementById('question').focus();
      return (isError = true);
    }
    if (!answer.trim()) {
      console.log('answer');
      handleSnakbarOpen('Please enter answer', 'error');
      document.getElementById('answer').focus();
      return (isError = true);
    }
    console.log('finish');
    return isError;
  };

  const handleChange = event => {
    console.log(event.target.value);
    setCategoryId(event.target.value);
  };

  const clearStates = () => {
    setId('');
    setCategoryId('');
    setQuestion('');
    setAnswer('');
    setApplicableFor('');
    setStatus(false);
    setEditObj({});
  };

  const onSubmit = async e => {
    e.preventDefault();

    setLoading(true);
    let response;
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    try {
      if (addForm) {
        console.log('addForm', question, answer, applicableFor, status);
        response = await axios({
          url: `/api/v1/private/category/${categoryId}/question`,
          method: 'post',
          data: { question, answer, applicableFor, status },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log('addForm Submit', question, answer, applicableFor, status);
        if (selectedId === categoryId) {
          setList([...list, response.data.data]);
        }
        clearStates();
        console.log('addForm response', response);
      } else if (editForm) {
        response = await axios({
          url: `/api/v1/private/category/${selectedId}/question/${id}`,
          method: 'put',
          data: { question, answer, applicableFor, status },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log('editForm Submit', id, question, answer, applicableFor, status);
        console.log('editForm response', response);

        list[editIndexNo] = response.data.data;
        setRefresh(!refresh);
      }

      closeAddDialog();
      activeAddForm();
      handleSnakbarOpen(response.data.message, 'success');
    } catch (error) {
      console.log('error', error);
      console.log('errorresponse', error.response);

      handleSnakbarOpen(error.response.data.errors.toString(), 'error');

      setLoading(false);
    }
    setLoading(false);
    // }
  };

  const handleSwitch = () => {
    setStatus(!status);
  };

  useEffect(() => {
    console.log('editObj');
    if (editObj.id) {
      setAddForm(false);
      setEditForm(true);
      setId(editObj.id);
      setApplicableFor(editObj.applicableFor);
      setQuestion(editObj.question);
      setAnswer(editObj.answer);

      setStatus(editObj.status);
    }
  }, [editObj]);

  const activeAddForm = () => {
    clearStates();

    // setEditForm(false);
    // setAddForm(true);
  };

  useEffect(() => {
    if (addDialog === false) {
      activeAddForm();
    }
  }, [addDialog]);
  return (
    <React.Fragment>
      {/* <div className={classes.titleDiv}>
        {editForm && (
          <div className={classes.iconDiv}>
            <IconButton aria-label="close" color="inherit" size="small" onClick={activeAddForm}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </div>
        )}
        <Typography variant="h4" className={`${classes.marginStyle} ${classes.alignCenter}`}>
          {editForm ? 'Update Question' : 'Add Question'}
        </Typography>
      </div> */}

      <div className={classes.titleDiv}>
        <div className={classes.iconDiv}>
          <IconButton
            style={{ background: 'gainsboro' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              closeAddDialog();
              activeAddForm();
            }}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </div>

        <Typography variant="h1" className={` ${classes.alignCenter}`}>
          {editForm ? 'Update Question' : 'Add Question'}
        </Typography>
      </div>

      {addForm && (
        <FormControl variant="outlined" fullWidth size="small" className={`${classes.marginStyle} ${classes.selectStyle}`}>
          <InputLabel id="demo-simple-select-outlined-label">Select Category</InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="categoryId"
            value={categoryId}
            onChange={handleChange}
            label="Select Category">
            {categoryList &&
              categoryList.map((item, i) => (
                <MenuItem key={i} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      )}

      <TextField
        id="applicableFor"
        label="Applicable For"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={applicableFor}
        onChange={e => setApplicableFor(e.target.value)}
      />
      <TextField
        id="question"
        label="Question"
        multiline
        rows={4}
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={question}
        onChange={e => setQuestion(e.target.value)}
      />
      <TextField
        id="answer"
        label="Answer"
        multiline
        rows={4}
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={answer}
        onChange={e => setAnswer(e.target.value)}
      />

      <div className={`${classes.marginStyle} ${classes.alignCenter}`}>
        <FormControlLabel
          control={<Switch checked={status} onChange={handleSwitch} name="status" color="primary" />}
          label="Status"
          labelPlacement="start"
        />
      </div>
      {/* <div className={classes.marginStyle}>
        {loading ? <LinearProgress /> : null}
        <Button variant="contained" color="primary" disabled={loading} fullWidth onClick={onSubmit}>
          {editForm ? 'Update' : 'Save'}
        </Button>
      </div> */}

      <div className={classes.buttonMarginStyle}>
        {/* {loading ? <LinearProgress /> : null} */}

        <Button
          variant="contained"
          className={classes.buttonStyle}
          color="primary"
          disabled={loading}
          fullWidth
          onClick={onSubmit}>
          {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
          {editForm ? 'Update' : 'Save'}
        </Button>
      </div>
    </React.Fragment>
  );
};

export default QuestionAddEdit;
